export const DESIGN_IMAGE_LIST_PRESET = [
  {
    displayedName: 'Дизайнерский проект ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'dizaynerskiy-proekt-vannoy-komnaty',
    style: 'design',
  },
  {
    displayedName: 'Сила и роскошь: ванная комната с плиткой под мрамор',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'sila-i-roskosh-vannaya-komnata-s-plitkoy-pod-mramor',
    style: 'design',
  },
  {
    displayedName: 'Тренды дизайна в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'trendy-dizayna-v-vannoy-komnate',
    style: 'design',
  },
  {
    displayedName: 'Гармония в ритме ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'garmoniya-v-ritme-vannoy-komnaty',
    style: 'design',
  },
  {
    displayedName: 'Прямоугольные формы в мраморной ванной',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg', '6.jpg/6.jpg'],
    productName: 'pryamougolnye-formy-v-mramornoy-vannoy',
    style: 'design',
  },
  {
    displayedName: 'Светлая и стильная ванная комната с душем',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg'],
    productName: 'svetlaya-i-stilnaya-vannaya-komnata-s-dushem',
    style: 'design',
  },
  {
    displayedName: 'Песчаные оттенки и черные контрасты в ванной',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg'],
    productName: 'peschanye-ottenki-i-chernye-kontrasty-v-vannoy',
    style: 'design',
  },
  {
    displayedName: 'Ванная комната повышенной индивидуальности',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-povyshennoy-individualnosti',
    rating: 1001,
    style: 'design',
  },
  {
    displayedName: 'Сосредоточиться на спокойствии в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'sosredotochitsya-na-spokoystvii-v-vannoy-komnate',
    style: 'design',
  },
  {
    displayedName: 'Аутентичная атмосфера в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'autentichnaya-atmosfera-v-vannoy-komnate',
    style: 'design',
  },
  {
    displayedName: 'Совершенные контрасты в ванной',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'sovershennye-kontrasty-v-vannoy',
    style: 'design',
  },
  {
    displayedName: 'Монохромный баланс в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'monohromnyy-balans-v-vannoy-komnate',
    style: 'design',
  },
  {
    displayedName: 'Дизайнерская ванная для гостиницы',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'dizaynerskaya-vannaya-dlya-gostinicy',
    style: 'design',
  },
  {
    displayedName: 'Черничная элегантность: гармония материалов в ванной',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'chernichnaya-elegantnost-garmoniya-materialov-v-vannoy',
    style: 'design',
  },
  {
    displayedName: 'Дизайнерская ванная в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'dizaynerskaya-vannaya-v-stile-loft',
    style: 'design',
  },
  {
    displayedName: 'Графичный минимализм в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'grafichnyy-minimalizm-v-vannoy-komnate',
    rating: 1003,
    style: 'design',
  },
  {
    displayedName: 'Мрамор и дерево в неоклассической ванной',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'mramor-i-derevo-v-neoklassicheskoy-vannoy',
    style: 'design',
  },
  {
    displayedName: 'Современная классика с черными акцентами в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'sovremennaya-klassika-s-chernymi-akcentami-v-vannoy-komnate',
    style: 'design',
  },
  {
    displayedName: 'Индивидуальное решение для ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'individualnoe-reshenie-dlya-vannoy-komnaty',
    style: 'design',
  },
  {
    displayedName: 'Большая ванная комната в современном исполнении',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'bolshaya-vannaya-komnata-v-sovremennom-ispolnenii',
    style: 'design',
  },
  {
    displayedName: 'Эстетика ванной комнаты: графичные линии и монохром',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'estetika-vannoy-komnaty-grafichnye-linii-i-monohrom',
    style: 'design',
  },
];
